// NPM Imports
import React, { Component } from "react";
import queryString from "query-string";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import { Toastr, Button } from "../../../revvComponents";

// Redux

// import ExportMsWord from "./ExportMsWord";

// Internal Imports
import { EVENTS, LOADING_MSG } from "../../../constants";
import { GlobalUtils, AmplitudeUtils } from "../../../utils";
import {
  downloadSSRPdf,
  exportFillablePDF,
} from "../../../actions/QuoteDocuments/services";
import { exportSharedDocument } from "../../../actions/SharedDocumentActions/sharedDocumentServices";
import { getExportContent } from "../../../utils/documentUtils";
import LZLoader from "../../../commonComponents/LZLoader";

// Destructuring
const { handleApiErrMsg } = GlobalUtils;
const { amplitudeLogEvent } = AmplitudeUtils;

class ExportDocumentBtn extends Component {
  state = {
    hasDownloadQueryParam: false,
    loader: false,
    showMenu: false,
  };

  componentDidMount() {
    const { search } = window.location;
    const queryParams = queryString.parse(search);
    if (queryParams) {
      const paramKeys = Object.keys(queryParams);
      // If download params is available & has pdf as value
      if (paramKeys.includes("download") && queryParams.download === "pdf") {
        this.setState({ hasDownloadQueryParam: true }, () => {
          this._exportPdfDocument();
        });
      }
    }
    document.addEventListener("mousedown", this.handleClick, false);
  }

  createExportRef = element => {
    this.exportRef = element;
  };

  createMsWordExportRef = element => {
    this.exportMsWordRef = element;
  };

  _closeOptionListRef = () => {
    this.setState({ showMenu: false });
  };

  componentWillUnMount = () => {
    document.removeEventListener("mousedown", this.handleClick, false);
  };

  _exportDocument = docType => {
    // this.props.toggleLoader(true);
    const { components } = this.props;
    const {
      id: docID,
      docNo,
      documentStatus,
      documentTag,
      template_id: templateID,
    } = this.props.document;
    const newDocument = { ...this.props.document };
    const downloadPdfName = `${this.props.document.name}.pdf`;
    // const documentSectionHTML = document.getElementsByClassName(
    //   "document-view-main-container",
    // )[0];
    // const html =
    //   documentSectionHTML && documentSectionHTML.innerHTML.length > 0
    //     ? documentSectionHTML.innerHTML
    //     : "";
    const previewContent = getExportContent(newDocument, components);
    previewContent.event = "download";

    const event = "download";
    let exportDoc = () => downloadSSRPdf(docID, event);
    if (this.props.isSharedDocument) {
      exportDoc = () => exportSharedDocument(docID, this.props.sharingHash);
    }
    exportDoc()
      .then(response => {
        // this.props.toggleLoader(false);
        this.setState({ showMenu: false });
        // get the file type
        let docMIMEType = "application/pdf";
        if (docType === "docx") {
          docMIMEType =
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
        }
        const file = new Blob([response], {
          type: docMIMEType,
        });
        // IE11 & Edge
        if (navigator.msSaveBlob) {
          navigator.msSaveBlob(file, downloadPdfName);
        } else {
          // In FF link must be added to DOM to be clicked
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(file);
          link.setAttribute("download", downloadPdfName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
        Toastr.showToastr({
          type: "success",
          message: "Your document has been downloaded successfully.",
          timeout: 3000,
        });
        amplitudeLogEvent(EVENTS.EVENT_NAMES.DOCUMENT_DOWNLOADED, {
          initiatedFrom: "Document",
          status: documentStatus && documentStatus.name,
          tag: documentTag && documentTag.name,
          DocumentID: docID,
          templateID,
          downloadType: docType,
        });
        // * IF DOWNLOAD QUERY PARAM IS PRESENT REMOVE IT BY RELOADING THE PAGE
        if (this.state.hasDownloadQueryParam) {
          const url = `${window.location.protocol}//${window.location.host}/documents/${docNo}`;
          window.history.replaceState({ path: url }, "", url);
          this.setState({
            loader: false,
            hasDownloadQueryParam: false,
          });
        } else {
          this.setState({
            loader: false,
            hasDownloadQueryParam: false,
          });
        }
      })
      .catch(error => {
        // this.props.toggleLoader(false);
        this.setState({ showMenu: false, hasDownloadQueryParam: false });
        console.error(error);
        Toastr.showToastr({
          type: "failure",
          message: handleApiErrMsg(error),
          timeout: 3000,
        });
        this.setState({
          loader: false,
        });
      });
  };

  _exportPdfDocument = e => {
    if (e) {
      e.preventDefault();
    }
    const { id: docID } = this.props.document;
    if (this.props.isFillablePDF && this.props.docStatus !== "COMPLETED") {
      this.setState({
        loader: true,
      });
      const exportDoc = () => exportFillablePDF(docID);
      exportDoc()
        .then(response => {
          // get the file type
          const docMIMEType = "application/pdf";
          const file = new Blob([response], {
            type: docMIMEType,
          });
          if (navigator.msSaveBlob) {
            navigator.msSaveBlob(file, this.props.docName);
          } else {
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(file);
            link.setAttribute("download", this.props.docName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
          Toastr.showToastr({
            type: "success",
            message: "Your document has been downloaded successfully.",
            timeout: 3000,
          });
          this.setState({
            loader: false,
          });
        })
        .catch(error => {
          this.setState({
            loader: false,
          });
          console.error(error);
          Toastr.showToastr({
            type: "failure",
            message: handleApiErrMsg(error),
            timeout: 3000,
          });
        });
    } else if (this.props.isPdfDocument) {
      window.open(this.props.pdfUrl, "_blank");
    } else {
      this.setState({
        loader: true,
      });
      this._exportDocument("pdf");
    }
  };

  _exportDocxDocument = e => {
    this.setState({
      loader: true,
      // message: "Docx",
    });
    e.preventDefault();
    this._exportDocument("docx");
  };

  showMenu = event => {
    event.preventDefault();
    const { showMenu } = this.state;
    this.setState({ showMenu: !showMenu });
  };

  handleClick = e => {
    if (
      (this.exportRef && this.exportRef.contains(e.target)) ||
      (this.exportMsWordRef && this.exportMsWordRef.contains(e.target))
    ) {
      return;
    }
    this.setState({ showMenu: false });
  };

  render() {
    return (
      <div className="btn-export-wrapper" ref={this.createExportRef}>
        {this.state.loader && (
          <LZLoader
            className="saving-document"
            label={LOADING_MSG.DOCUMENT_DOWNLOADING}
            theme="dark"
            fullScreen
          />
        )}
        {this.props.isSharedDocument ? (
          <span
            className={`exportdocumentbtn-recipient-download-btn ${this.props.className}`}
            data-test="exportdocumentbtn-recipient-download-btn"
            onClick={this._exportPdfDocument}
            tabIndex="0"
            onKeyDown={() => {}}
            role="button">
            <FontAwesomeIcon
              icon={["far", "download"]}
              className="exportdocumentbtn-recipient-download-icon"
            />
            {this.props.usedFor === "DROPDOWN" && "Download"}
          </span>
        ) : (
          <div>
            <Button
              className="revv-btn-secondary export-document"
              data-test="download-doc-stage-btn"
              onClick={e => this._exportPdfDocument(e)}
              onKeyPress={e => this._exportPdfDocument(e)}>
              Download
            </Button>

            {/* Download button with dropdown options */}
            {/* <Button
              className="revv-btn-secondary export-document"
              onClick={this.showMenu}>
              Download{" "}
            </Button> */}
            {this.state.showMenu && (
              <div className="export-dropdown docs">
                <ul className="export-dd-items">
                  <li>
                    <div
                      className="export-list-item"
                      role="button"
                      tabIndex="0"
                      onClick={e => this._exportPdfDocument(e)}
                      onKeyPress={e => this._exportPdfDocument(e)}>
                      <i className="file-pdf">
                        <FontAwesomeIcon icon={["fas", "file-pdf"]} />
                      </i>
                      PDF Document (.pdf)
                    </div>
                  </li>
                  {/* <li>
                    <ExportMsWord
                      popupRef={this.createMsWordExportRef}
                      optionCloseList={this._closeOptionListRef}
                      exportDocxDocument={this._exportDocxDocument}
                    />
                  </li> */}
                </ul>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    document,
    document: { isPdfDocument, pdfUrl, name: docName },
    components,
    isFillablePDF,
  } = state.DocumentStore;

  return {
    components,
    document,
    isPdfDocument,
    pdfUrl,
    isFillablePDF,
    docName,
  };
};

export default connect(mapStateToProps, null)(ExportDocumentBtn);
